module.exports = __webpack_public_path__ + "static/media/2whitepine2text.ba3c1c89.jpg";